import styled, {css} from "styled-components"
import {Tooltip} from "react-bootstrap"
import {TextButton} from "@irati/ui/src/Button"

import LabelValue from "../LabelValue"

export const StyledTooltip = styled(Tooltip)`
  .tooltip-inner {
    max-width: 300px;
    word-wrap: break-word;
  }
`

export const Pin = styled(LabelValue)`
  margin-bottom: 3px;
`

export const CopyCodeButton = styled(TextButton)`
  ${({theme}) => css`
    color: ${theme.colors.primary1};
    font-size: ${theme.spacing.two};
  `}
`

export const Image = styled.img`
  ${({theme}) => css`
    margin-right: ${theme.spacing.half};
  `}
`
